import { render, staticRenderFns } from "./editPrivilegeGroup.vue?vue&type=template&id=27afbc0e&scoped=true"
import script from "./editPrivilegeGroup.vue?vue&type=script&lang=js"
export * from "./editPrivilegeGroup.vue?vue&type=script&lang=js"
import style0 from "./editPrivilegeGroup.vue?vue&type=style&index=0&id=27afbc0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27afbc0e",
  null
  
)

export default component.exports